import type { IOrganizationMenuQuery } from '../interfaces/menu';

import { ProxyClient } from './client/ProxyClient';

export const loadOrganizationMenu = async (params: IOrganizationMenuQuery) => {
  const { data } = await ProxyClient.get('/organizationMenu', { params });

  return data;
};
